import styles from './contextCard.module.scss'

export default function ContextCardInner({ children, plain }) {
  const className = plain ? `${styles.inner} ${styles.innerPlain}` : styles.inner
  return <div className={className}>{children}</div>
}
